import { DEFAULT_ACTION_MODE } from 'src/constants/responsiveTable'

export default function () {
  return {
    hideFields: {},
    actionMode: {},
    defaultActionMode: DEFAULT_ACTION_MODE
  }
}
